import { render } from "./BasePageTitleBar.vue?vue&type=template&id=46c5afb5"
import script from "./BasePageTitleBar.vue?vue&type=script&lang=js"
export * from "./BasePageTitleBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/helpers/BasePageTitleBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46c5afb5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46c5afb5', __exports__)) {
    api.reload('46c5afb5', __exports__)
  }
  
  module.hot.accept("./BasePageTitleBar.vue?vue&type=template&id=46c5afb5", () => {
    api.rerender('46c5afb5', render)
  })

}


export default __exports__